import "../styles/ui/ui.scss"

const Button = ({text, color, ...props}) => {
    return (
        <button className={`btn ${color}-btn`} {...props}>
            <h1>
                {text}
            </h1>
        </button>
    )
}

export default Button;